import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

const DynamicListWrapper = styled.div`
  *[draggable='true'] {
    -moz-user-select: none;
    -khtml-user-drag: element;
    -webkit-user-drag: element;
    -khtml-user-select: none;
    -webkit-user-select: none;
    cursor: grab;
  }
`;
const DynamicItemWrapper = styled.div`
  display: block;
`;
const DynamicListItem = styled.div`
  display: flex;
  justify-content: space-evenly;
  z-index: 1;
  background-color: ${theme.colors.neutral.bg['weak']};
  margin: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
  padding: ${theme.spacing['spacing-3']};
  border-radius: ${theme.borderRadius['border-radius-2']};
  border: 1px solid ${theme.colors.neutral.border.weak};
  box-shadow: 0px 2px 4px -2px ${theme.colors.neutral.border.weak},
    0px 2px 4px -2px ${theme.colors.neutral.border.weak};

  &:active {
    ${({ isDraggable }) =>
      isDraggable &&
      css`
        background-color: ${theme.colors.neutral.bg['regular']};
      `}
    box-shadow: 0px 2px 4px -2px ${theme.colors.neutral.border.weak},
      0px 2px 4px -2px ${theme.colors.neutral.border.weak};
  }
`;
const DynamicListItemValue = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  z-index: 0;
`;
const DynamicListItemDraggable = styled.div`
  z-index: 0;
  display: flex;
  justify-content: flex-end;
`;
const DynamicListItemPlaceHolder = styled.div`
  cursor: grabbing;
  height: ${theme.spacing['spacing-8']};
  margin: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
  padding: ${theme.spacing['spacing-3']};
  background-color: ${theme.colors.neutral.bg['regular']};
  box-shadow: 0px 2px 4px -2px ${theme.colors.neutral.border.weak},
    0px 2px 4px -2px ${theme.colors.neutral.border.weak};
`;

export {
  DynamicListItem,
  DynamicListItemValue,
  DynamicListItemDraggable,
  DynamicListItemPlaceHolder,
  DynamicItemWrapper,
  DynamicListWrapper,
};
